import { render } from "./ModalCreateOrEdit.pug?vue&type=template&id=d9d3824c&lang=pug"
import script from "./ModalCreateOrEdit.js?vue&type=script&lang=js"
export * from "./ModalCreateOrEdit.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__